import { SVGProps } from 'react';

export const Edit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g id="Fill 1449 + Fill 1450 + Fill 1451">
      <path
        id="Fill 1449"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.79755 2.64844L1.94336 9.50423L6.49682 14.0577L13.3518 7.2027L8.79755 2.64844Z"
        fill="currentColor"
      />
      <path
        id="Fill 1450"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4827 6.07162L15.0586 5.49644C16.3138 4.24047 16.3138 2.19813 15.0578 0.941372C13.8027 -0.313791 11.7595 -0.313791 10.5036 0.941372L9.9292 1.51735L14.4827 6.07162Z"
        fill="currentColor"
      />
      <path
        id="Fill 1451"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.12059 14.9428L0.995918 15.974C0.723126 16.0412 0.435135 15.9612 0.236741 15.7628C0.0375465 15.5644 -0.0416511 15.2764 0.0263469 15.0036L1.05672 10.8789L5.12059 14.9428Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
